export default [
    {
        path: '/commandes',
        name: 'orders',
        component: () => import('../views/OrdersManager.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'commandes',
            description: 'Gestion des commandes'
        }
    },
    {
        path: '/commande/:id',
        name: 'order',
        component: () => import('../views/OneOrderManager.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'commande',
            description: 'Gestion de commande'
        }
    }
]
